import { Gate, GateContext } from './gateTypes';

export const AuthGate: Gate = {
  name: 'auth',
  check: async (ctx: GateContext) => {
    if (!ctx.user) {
      return { allow: false, reason: 'AUTH_REQUIRED', action: 'REDIRECT', redirectTo: '/login' };
    }
    return { allow: true };
  },
};

export const SubscriptionGate: Gate = {
  name: 'subscription',
  check: async (ctx: GateContext) => {
    try {
      const billing = await ctx.refreshBilling();
      if (billing?.active && billing.status === 'active') {
        return { allow: true };
      }
      return {
        allow: false,
        reason: 'SUBSCRIPTION_REQUIRED',
        action: 'PAYWALL',
        redirectTo: ctx.returnUrl,
      };
    } catch (error: any) {
      return { allow: false, reason: error?.message || 'Billing check failed', action: 'TOAST' };
    }
  },
};

export const CreditsGate: Gate = {
  name: 'credits',
  check: async () => ({ allow: true }),
};
